export default __webpack_public_path__ + "static/media/Hajj_content_website_icon_01.4f04f2e2.svg";